// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 132) return "static/chunks/a5d1118a-4e18abbf46a2cd60.js";
	if (chunkId === 342) return "static/chunks/342-a6117f64d08df32a.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"f8219b01f6b7c46c","205":"2e90144ef4045da8","319":"0cbc2894a3f1b950","340":"08bba13991fca47e","367":"147e42e4cbdbc2b5","639":"33d53f572023d605","748":"1a361275d2d1f101"}[chunkId] + ".js";
};